import { t } from "@/i18n-js/instance";

export const ChatError = () => (
  <div className="text-dark px-8 font-medium">
    {t("chat_space.error_message")}
  </div>
);
